/**
 * WHY A SAVE DID NOT GO THROUGH, in one word the screen can translate.
 * The red line must always name the real cause — never a generic "try again".
 */
export const saveErrorKey = (status, reason) => {
    const why = String(
        (reason && reason.reason) || reason || '').trim().toLowerCase();
    if (status === 0) return 'offline';
    if (why === 'phone_taken') return 'phoneTaken';
    if (why === 'not_registered') return 'notRegistered';
    if (why === 'mismatch' || why === 'wrong_pin') return 'wrongPin';
    if (why === 'pin_four_digits') return 'pinFourDigits';
    if (why === 'email_required') return 'emailNeeded';
    if (why === 'consent_required') return 'consentNeeded';
    if (why === 'table_number_required') return 'tableNeeded';
    if (why === 'locked') return 'locked';
    if (why === 'not_enabled') return 'accountsOff';
    if (why === 'sign_in_first') return 'signInFirst';
    if (why === 'winner_pick_off' || why === 'star_pick_off') return 'pickOff';
    if (why === 'no_game') return 'noGame';
    if (why === 'game_started' || why === 'locked_game') return 'gameStarted';
    if (status >= 500) return 'server';
    return 'generic';
};

/** The player whose phone it is, when the server named them. */
export const takenBy = (reason) =>
    (reason && typeof reason === 'object' && reason.player) ? reason.player : '';
